import React from 'react'

const ProjectManagement = () => {
    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <ul className="breadcrumb-animation">
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                </ul>
                <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                    <h3 className="display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
                        Project Management
                    </h3>
                    <ol
                        className="breadcrumb justify-content-center mb-0 wow fadeInDown"
                        data-wow-delay="0.3s"
                    >
                        <li className="breadcrumb-item">
                            <a href="/">Home</a>
                        </li>
                        <li className="breadcrumb-item active text-primary">
                            Project Management
                        </li>
                    </ol>
                </div>
            </div>
            {/* Header End */}
            {/* About Start */}
            <div className="container-fluid overflow-hidden py-5 mt-5">
                <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="RotateMoveLeft">
                                <img src="img/services/5.png" className="img-fluid w-100" alt="" />
                            </div>
                        </div>
                        <div
                            className="col-lg-6 wow fadeInUp d-flex align-items-center"
                            data-wow-delay="0.3s"
                        >
                            <div>
                                <h1 className="display-5 mb-4">
                                    Get Started Easily With a Personalized Product Tour
                                </h1>
                                <p className="mb-4">
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                    Accusantium, suscipit itaque quaerat dicta porro illum, autem,
                                    molestias ut animi ab aspernatur dolorum officia nam dolore.
                                    Voluptatibus aliquam earum labore atque.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}
        </>

    )
}

export default ProjectManagement